export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id || "Id no disponible",
    col_descripcion: item.col_descripcion || "Color no disponible",
  }));

  